import { createScreenViewedEvent, createSubmittedEvent, track } from "./base"

export const buyBoxViewed = () => {
  track(
    createScreenViewedEvent({
      current_screen: "Buy Box",
      from_screen: "Properties",
    })
  )
}

export const buyBoxSubmitted = ({
  priceMax,
  priceMin,
  arvMax,
  arvMin,
  yrBltMin,
  yrBltMax,
  sqftMin,
  sqftMax,
  profitValue,
  bedsValue,
  bathsValue,
  zipCodes,
}: {
  priceMax: number
  priceMin: number
  arvMax: number
  arvMin: number
  yrBltMin: number
  yrBltMax: number
  sqftMin: number
  sqftMax: number
  profitValue: number
  bedsValue: string[]
  bathsValue: string[]
  zipCodes: string[]
}) => {
  track(
    createSubmittedEvent({
      object_name: "Buy Box",
      current_screen: "Buy Box",
      to_screen: "Properties",
      component_type: "button",
      component_text: "Save",
      submitted_values: {
        price_max: priceMax,
        price_min: priceMin,
        arv_max: arvMax,
        arv_min: arvMin,
        yr_blt_max: yrBltMax,
        yr_blt_min: yrBltMin,
        sqft_max: sqftMax,
        sqft_min: sqftMin,
        profit_value: profitValue,
        beds_value: bedsValue,
        baths_value: bathsValue,
        zipCodes,
      },
    })
  )
}
